import styled from 'styled-components';
import Button from '../button';

export const OptionsList = styled.ul`
  list-style-type: none;
  padding-left: 0;
`;

export const Label = styled.label`
  padding-left: ${({ theme }) => theme.spacing.medium};
  position: relative;
`;

export const Input = styled.input`
  vertical-align: middle;
  position: absolute;
  left: ${({ theme }) => theme.spacing.tiny};
  top: 3px;
`;

export const QuestionBox = styled.div`
  background: ${({ theme }) => theme.palette.lightBackground};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  padding: ${({ theme }) => theme.spacing.standard};
  border: none;
`;

export const Heading = styled.h3`
  font-size: ${({ theme }) => theme.fontsize.h4};
  border-bottom: 1px solid ${({ theme }) => theme.palette.border};
  padding-bottom: ${({ theme }) => theme.spacing.standard};
  margin-top: 0;
`;

export const StartAgain = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;
